import React from 'react';
import { DEAL_MODEL_LIST } from '../../../data/diagnostic/dealModels';

const StepDealModel = ({ niche, selectedId, onSelect, showValidation = false }) => {
  const suggestedId = niche ? niche.defaultDealModel : null;
  const needsSelection = showValidation && !selectedId;

  return (
    <div className="dg-step">
      <h2 className="dg-step-title">Как вам платят?</h2>
      <p className="dg-step-lead">
        От этого зависит, как считать выручку. Мы уже выбрали вариант, который чаще встречается
        в вашей нише — поменяйте, если у вас иначе.
      </p>

      {needsSelection ? (
        <p className="dg-step-hint-error" role="alert">
          Выберите, как вам платят
        </p>
      ) : null}

      <div className={`dg-deal-list${needsSelection ? ' is-invalid' : ''}`}>
        {DEAL_MODEL_LIST.map((model) => (
          <button
            key={model.id}
            type="button"
            className={`dg-deal-card${selectedId === model.id ? ' is-selected' : ''}`}
            onClick={() => onSelect(model.id)}
            aria-pressed={selectedId === model.id}
          >
            <span className="dg-deal-head">
              <span className="dg-deal-name">{model.label}</span>
              {model.id === suggestedId ? (
                <span className="dg-deal-badge">обычно в вашей нише</span>
              ) : null}
            </span>
            <span className="dg-deal-desc">{model.description}</span>
            <span className="dg-deal-examples">Например: {model.examples}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default StepDealModel;
